import { render } from "./EditDistrict.vue?vue&type=template&id=2721a48e&scoped=true"
import script from "./EditDistrict.vue?vue&type=script&lang=js"
export * from "./EditDistrict.vue?vue&type=script&lang=js"

import "./EditDistrict.vue?vue&type=style&index=0&id=2721a48e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2721a48e"]])

export default __exports__